/**
 * Выпадающая форма выбора порядка сортировки (GET, перезагрузка страницы).
 */
class PostSortSelect {

    constructor() {
        document.querySelectorAll('[data-post-sort-select]').forEach((root) => {
            this.bindRoot(root);
        });
    }

    bindRoot(root) {
        const trigger = root.querySelector('.post-sort-select__trigger');
        const dropdown = root.querySelector('.post-sort-select__dropdown');
        const form = root.querySelector('.post-sort-select__form');

        if (!trigger || !dropdown || !form) {
            return;
        }

        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            this.toggle(root, dropdown);
        });

        form.addEventListener('change', (e) => {
            const input = e.target;
            if (input instanceof HTMLInputElement && input.classList.contains('post-sort-select__input')) {
                form.requestSubmit();
            }
        });

        document.addEventListener('click', (e) => {
            if (!root.contains(e.target)) {
                this.close(root, dropdown);
            }
        });

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && root.classList.contains('post-sort-select--open')) {
                this.close(root, dropdown);
                trigger.focus();
            }
        });
    }

    /**
     * Показывает или скрывает панель опций.
     */
    toggle(root, dropdown) {
        const open = root.classList.toggle('post-sort-select--open');
        dropdown.toggleAttribute('hidden', !open);
    }

    /**
     * Скрывает панель опций.
     */
    close(root, dropdown) {
        root.classList.remove('post-sort-select--open');
        dropdown.setAttribute('hidden', '');
    }
}

export default PostSortSelect;